<template>
  <div class="nothing" v-if="!show.length">
    <img src="@/assets/images/img_nohavedata.png" alt />
    <p>{{ description || "暂无数据信息" }}</p>
  </div>
</template>
<script>
export default {
  name: "nothing",
  props: ["show", "description"],
};
</script>
<style lang="scss" scoped>
.nothing {
  text-align: center;
  margin-top: 60px;
  img {
    width: 160px;
    height: 160px;
  }
  p {
    font-size: 16px;
    color: rgb(191, 191, 191);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/DefaultPage.vue